import React from 'react';
import Event from './Event'; // Import the Event component

const EventsSection = (props) => (
  <>
    <p style={{ fontSize: '40px', fontWeight: '500', textAlign: 'center', marginTop: '20px' }}>{`${props.tense} Events`}</p>
    <div className="events-section" style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap'}}>
    {
      props.events.map((event)=>(
        <Event
          event={event}
        />
      ))
    }
    </div>
  </>
);

export default EventsSection;
